function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6 6.9999V4.1999L11.7527 3.7763C11.414 3.6069 11.2 3.26064 11.2 2.88187L11.2 1.3999H16.8V2.88187C16.8 3.26064 16.586 3.6069 16.2472 3.7763L15.4 4.1999V6.9999",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.40015 7V7.5C8.40015 9.15685 9.74329 10.5 11.4001 10.5H16.6001C18.257 10.5 19.6001 9.15685 19.6001 7.5V7",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.40015 6C7.84786 6 7.40015 6.44772 7.40015 7C7.40015 7.55228 7.84786 8 8.40015 8V6ZM19.6001 8H20.6001V6H19.6001V8ZM8.40015 8H19.6001V6H8.40015V8Z",
  fill: "#02BC4D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6 10.5V9.5C12.1112 9.5 11.694 9.85341 11.6136 10.3356L12.6 10.5ZM15.4 10.5L16.3864 10.3356C16.306 9.85341 15.8888 9.5 15.4 9.5V10.5ZM11.5822 16.6071L11.9855 17.5221C12.294 17.3862 12.5131 17.104 12.5686 16.7715L11.5822 16.6071ZM9.35649 25.9L8.58297 26.5338C8.7729 26.7656 9.0568 26.9 9.35649 26.9V25.9ZM18.6435 25.9V26.9C18.9432 26.9 19.2271 26.7656 19.417 26.5338L18.6435 25.9ZM16.4179 16.6071L15.4315 16.7715C15.4869 17.104 15.7061 17.3862 16.0145 17.5221L16.4179 16.6071ZM12.6 11.5H15.4V9.5H12.6V11.5ZM12.5686 16.7715L13.5864 10.6644L11.6136 10.3356L10.5958 16.4427L12.5686 16.7715ZM11.1788 15.692C8.71977 16.776 7 19.2361 7 22.1H9C9 20.057 10.2254 18.298 11.9855 17.5221L11.1788 15.692ZM7 22.1C7 23.7815 7.59413 25.3269 8.58297 26.5338L10.13 25.2662C9.42331 24.4037 9 23.3026 9 22.1H7ZM9.35649 26.9H18.6435V24.9H9.35649V26.9ZM19.417 26.5338C20.4059 25.3269 21 23.7815 21 22.1H19C19 23.3026 18.5767 24.4037 17.87 25.2662L19.417 26.5338ZM21 22.1C21 19.2361 19.2802 16.776 16.8212 15.692L16.0145 17.5221C17.7746 18.298 19 20.057 19 22.1H21ZM14.4136 10.6644L15.4315 16.7715L17.4042 16.4427L16.3864 10.3356L14.4136 10.6644Z",
  fill: "#151515"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10005 18.1999L6.73939 15.8392C6.45808 15.5579 6.07655 15.3999 5.67873 15.3999H4.30005C3.47162 15.3999 2.80005 16.0715 2.80005 16.8999V22.9999C2.80005 23.8283 3.47162 24.4999 4.30005 24.4999H5.91756C6.16854 24.4999 6.4155 24.4369 6.63584 24.3167L14 20.2999L20.7185 24.6189C22.0496 25.4746 23.8001 24.5189 23.8001 22.9366V8.3999",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgHookah = function SvgHookah(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHookah, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hookah.574da435.svg";
export { ForwardRef as ReactComponent };